import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

import { trackedFunction } from 'reactiveweb/function';
import { TrackedMap } from 'tracked-built-ins';

import config from 'umg-ember-backend/config/environment';

const themeConfigV1 = {
  cms: {
    'article': {
      options: {
        displayVariants: [
          {
            value: 'TEASER_WITH_DETAIL',
            label: 'Teaser mit Detailseite',
          },
        ],
      },
    },
    'collection': {
      options: {
        displayVariants: {
          article: [
            {
              value: 'TEASER_WITH_DETAIL',
              label: 'Teaser mit Detailseite',
            },
          ],
          theme: [
            {
              value: 'COLLECTION_SLIDER',
              label: 'Slider',
            },
            {
              value: 'COLLECTION_GRID',
              label: 'Grid-Ansicht',
            },
          ],
          media_embed: [
            {
              value: 'COLLECTION_GRID',
              label: 'Grid-Ansicht',
            },
          ],
          product: [
            {
              value: 'COLLECTION_TABNAV',
              label: 'Tab-Ansicht',
            },
            {
              value: 'COLLECTION_SLIDER',
              label: 'Slider',
            },
            {
              value: 'COLLECTION_GRID',
              label: 'Grid-Ansicht',
            },
          ],
        },
      },
    },
    'hero-header': {
      contentItems: ['link'],
    },
    'mlp-column': {
      contentItems: [
        'article',
        'audioplayer',
        'asset',
        'mlp-countdown',
        'action',
        'html',
        'link',
        'live-event',
        'mlp-live-event-feed',
        'media-embed',
        'media-event',
        'mlp-news-feed',
        'newsletter',
        'product',
        'teaser',
        'mlp-text',
      ],
    },
    'mlp-countdown': {
      contentItems: [
        'artist',
        'article',
        'audioplayer',
        'asset',
        'collection',
        'action',
        'hero-header',
        'html',
        'link',
        'live-event',
        'mlp-live-event-feed',
        'media-embed',
        'media-event',
        'mlp-news-feed',
        'newsletter',
        'product',
        'product-family',
        'mlp-row',
        'teaser',
        'mlp-text',
        'spacer',
      ],
    },
    'mlp-page': {
      contentItems: [
        'artist',
        'article',
        'audioplayer',
        'asset',
        'mlp-countdown',
        'collection',
        'action',
        'mlp-voucher',
        'hero-header',
        'html',
        'link',
        'live-event',
        'mlp-live-event-feed',
        'media-embed',
        'media-event',
        'newsletter',
        'mlp-news-feed',
        'product',
        'product-family',
        'mlp-slider',
        'mlp-row',
        'spacer',
        'teaser',
        'mlp-text',
      ],
    },
    'mlp-row': {
      contentItems: ['mlp-column'],
    },
    'mlp-slider': {
      contentItems: ['asset', 'hero-header'],
    },
    'mlp-voucher': {
      contentItems: [
        'artist',
        'article',
        'audioplayer',
        'asset',
        'collection',
        'action',
        'hero-header',
        'html',
        'link',
        'live-event',
        'mlp-live-event-feed',
        'media-embed',
        'media-event',
        'newsletter',
        'mlp-news-feed',
        'product',
        'product-family',
        'mlp-product-feed',
        'mlp-row',
        'spacer',
        'teaser',
        'mlp-text',
      ],
    },
  },
};

export default class PageBuilderFrontendApiService extends Service {
  // Defaults
  @tracked useLocalhost = false;
  themeConfigs = new TrackedMap();
  fetchOptions = {
    mode: 'cors',
  };

  // Getter and setter
  get host() {
    if (this.useLocalhost) {
      return 'http://pagebuilder-api.localhost:3000';
    }

    return config.pageBuilderFrontendApiHost;
  }

  // Functions
  loadThemes = trackedFunction(this, async () => {
    const url = `${this.host}/themes`;
    const response = await fetch(url, this.fetchOptions);

    return await response.json();
  });

  async loadThemeConfig(host, mlp) {
    const theme = mlp.theme || 'default-v1';

    if (!mlp.isV2) {
      return themeConfigV1;
    }

    if (this.themeConfigs.has(theme)) {
      return this.themeConfigs.get(theme);
    }

    const url = `${host}/themes/${theme}`;
    const response = await fetch(url, this.fetchOptions);
    const themeConfig = await response.json();

    this.themeConfigs.set(theme, themeConfig);

    return themeConfig;
  }

  togglePageBuilderApi = () => {
    this.themeConfigs = new TrackedMap();
    this.useLocalhost = !this.useLocalhost;
  };
}
